import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-398f0d0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notion-user-area" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "notion-user-btn" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/icons/my-icons/user.png",
    class: "notion-user-avatar"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Popper, { placement: "bottom-end" }, {
      content: _withCtx(() => [
        _createVNode(_component_KTUserMenu)
      ]),
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}